import axios from 'axios';
import domainByEnv from './domainByEnv';
interface I_HandleProps {
    TravelType: string | number;
    Price: string | number;
    TourDays: number;
    NormGroup: string;
    GoDate: string;
    GroupID: string;
    NormGroupID: string;
    isCompared: boolean;
    setIsCompared: any;
}

interface I_GetProps {
    TourDays: number;
    GoDate: string;
    NormGroupID: string;
    NormGroup: string;
    GroupID: string;
    TravelType: string | number;
    setIsCompared: any;
}

// 比較按鈕api路徑使用共用功能，所以沒有/travel
const comparePath = domainByEnv() === '/travel' ? '' : domainByEnv()

export const handleCompare = async ({
    TravelType,
    Price,
    TourDays,
    NormGroup,
    GoDate,
    GroupID,
    NormGroupID,
    isCompared,
    setIsCompared,
}: I_HandleProps) => {
    try {
        // 先確定比較有沒有超過 3 筆
        const compareRes = await fetch(`${comparePath}/common/getcomparebytype`, {
            method: 'POST',
            credentials: 'include',
        });
        const compareData = await compareRes.json();

        // 收藏為 0 筆時，會回傳空陣列，但有團時會回傳物件，故以 Array.isArray 判斷
        // const groupList =
        //     !Array.isArray(compareData) && compareData.items[0].compareHref.split(',');
        // 已經三筆時，不能增加，但可以刪除
        // if (groupList.length === 3 && !isCompared) return alert('團體行程最多只能比較三筆');

        // 若已加入比較，刪除比較；若未加入比較，加入比較
        const insertQueryString = `{"traveltype":${TravelType},"price":${
            Price ? Number(Price.toString().replace(',', '')) : 0
        },"days":${TourDays},"productname":"${NormGroup}","departuredate":"${GoDate}","productid":"${GroupID}","normgroupid":"${NormGroupID}"}`;

        const deleteQueryString = `{"traveltype":${TravelType},"productid":"${GroupID}"}`;
        const queryString = isCompared ? deleteQueryString : insertQueryString;
        const api = isCompared ? 'deletecompare' : 'insertcompare';

        await fetch(`${comparePath}/common/${api}?jsonStr=${encodeURIComponent(queryString)}`, {
            method: 'POST',
        })
            .then((res) => {
                return res.json();
            })
            .then((result) => {
                if (api === 'insertcompare') {
                    if (result === 0) {
                        setIsCompared(true);
                    } else if (result === 1) {
                        alert('團體行程最多只能比較三筆');
                    } else if (result === 2) {
                        alert('團體自由行行程最多只能比較三筆');
                    }
                } else {
                    if (result === true) {
                        setIsCompared(false);
                    }
                }
            });
    } catch (err) {
        console.log('error =>', err);
    }
};

export const getIsCompared = async ({
    TourDays,
    GoDate,
    NormGroupID,
    NormGroup,
    GroupID,
    TravelType,
    setIsCompared,
}: I_GetProps) => {
    const queryObject = {
        days: TourDays.toString(),
        price: GoDate,
        departuredate: GoDate,
        normgroupid: NormGroupID,
        productname: NormGroup,
        productid: GroupID,
        traveltype: TravelType.toString(),
    };

    const queryString = new URLSearchParams(queryObject).toString();
    const { data: isCompare }: { data: boolean } = await axios.get(
        `${comparePath}/common/isincompare?${queryString}`
    );
    setIsCompared(isCompare);
};
